import React from 'react';
const bonuses = ['Thyroid Food Guide™', '30-Day Thyroid Meal Planner™', 'Thyroid-Friendly Grocery Shopping Guide™', '25 Delicious Thyroid-Friendly Desserts™', 'Energy & Metabolism Reset Guide™'];
const included = ['The Complete Thyroid Reset Cookbook™ 6-in-1 System', '60 Delicious Recipes', 'Over 300 Pages of Content', 'All 5 Exclusive Bonuses', 'Instant Digital Access'];
export function BonusSection() {
  return <>
      <section className="py-8 sm:py-12 px-4 bg-brand-cream" data-id="element-13">
        <div className="max-w-3xl mx-auto" data-id="element-14">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-center text-brand-text-dark mb-6" data-id="element-15">
            Plus, You'll Receive These 5 Exclusive Bonuses
          </h2>

          <div className="grid sm:grid-cols-2 gap-4" data-id="element-16">
            {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-brand-gold/40 p-5 rounded-lg text-center" data-id="element-17">
                <span className="text-3xl mb-2 block" data-id="element-18">🎁</span>
                <h3 className="text-base font-bold text-brand-text-dark" data-id="element-19">
                  {bonus}
                </h3>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-8 sm:py-12 px-4 bg-white" data-id="element-20">
        <div className="max-w-3xl mx-auto" data-id="element-21">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-center text-brand-text-dark mb-6" data-id="element-22">
            Here's Everything You'll Receive Today
          </h2>

          <div className="space-y-3" data-id="element-23">
            {included.map((item, i) => <div key={i} className="flex gap-3 items-start bg-brand-cream p-4 rounded-lg border border-brand-sage/30" data-id="element-24">
                <span className="text-brand-sage text-xl shrink-0" data-id="element-25">✅</span>
                <p className="text-base text-brand-text-dark font-medium" data-id="element-26">
                  {item}
                </p>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}